import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import { AppRoutes, MenuItens } from "../types";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";

export const MenuItem: MenuItens[] = [
  {
    name: "Dashboard",
    icon: <HomeIcon />,
    route: AppRoutes.dashboard,
  },
  // {
  //   name: "Usuários",
  //   icon: <PersonIcon />,
  //   route: AppRoutes.usuarios,
  // },
  { name: "Fornecedores", icon: <GroupIcon />, route: AppRoutes.fornecedores },
  {
    name: "Viagens",
    icon: <FlightTakeoffIcon />,
    route: AppRoutes.viagens,
  },
];
